import React, { createContext, useContext, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useOutsideClick } from './../../Hooks/useOutsideClick'
import './Menu.css'

export function Menu({ transition, withArrow, position, target, data , children}){

	const [isOpen, setIsOpen] = useState(false)
    const ref = useOutsideClick(() => setIsOpen(false));
     

	return (
		<div 
			className={`menu-dropdown `}
			// onClick={handleHeaderClick}
		>
			<div 
				className={`menu-target ${isOpen ? 'opened' : 'closed'}`}
				onClick={() =>  setIsOpen(!isOpen)}
                
				 
			>{target}</div>
			{
			isOpen && 
			<div 
				className={`menu-dropdown-items`}
                ref={ref}
				>
                <div>
					{
						data.map( (item , index) => {
							return (
								<div className='menu-dropdown-item' key={index}>
									<Link to={item?.link}>
										{ item?.icon && <div className="mitem-icon">{item?.icon}</div> }
										<div className="mitem-label">{item?.name}</div>
									</Link>
							</div>
							)
						})
					}
					 
				</div>    
			</div>
		}
		</div>	
	)
}

// const DropdownContext = createContext({
// 	isOpen: false,
// 	setIsOpen: () => true,
//   });
 
// export function Menu({ children }) {


// 	const [isOpen, setIsOpen] = useState(false)
// 	const handleHeaderClick = (event) => {
// 		// do something
// 		event.stopPropagation();
// 	};
	

// 	return (
// 		<DropdownContext.Provider value={{ isOpen , setIsOpen }}>
// 			<div 
// 				className={`menu-dropdown ${isOpen ? 'opened' : 'closed'}`}
// 				onClick={handleHeaderClick}
// 				>{children}</div>	
// 		</DropdownContext.Provider>
// 	)
// }

// function Target({ children }) {

// 	const { isOpen, setIsOpen } = useContext(DropdownContext);

// 	const ref = useOutsideClick(() => setIsOpen(false));

// 	return (
// 		<div 
// 			className={`menu-target ${isOpen ? 'opened' : 'closed'}`}
// 			onClick={() =>  setIsOpen(!isOpen)}
// 			ref={ref}
// 			><Link to="/pages" >Target</Link>{children}</div>
// 	)
// }

// function Dropdown({ children }) {

// 	const { isOpen, setIsOpen } = useContext(DropdownContext);


// 	return (
// 		<>
// 		{
// 			isOpen && 
// 			<div 
// 				className={`menu-dropdown-items`}
// 				>
//                     <Link to="/pages" >DROPDOWN</Link>
// 				<div>{children}</div>    
// 			</div>
// 		}
// 		</>
// 	)
// }
// function Item({ link , icon , children }) {

//     const navigate = useNavigate()
// 	return (
// 		<div className='menu-dropdown-item'>
			
// 			<Link to={link}>
// 				{ icon && <div className="mitem-icon">{icon}</div> }
// 				<div className="mitem-label">{children}</div>
// 			</Link>
// 		</div>
// 	)
// }

// Menu.Target = Target;
// Menu.Dropdown = Dropdown;
// Menu.Item = Item;


